import { render, staticRenderFns } from "./BlockForm.vue?vue&type=template&id=05d3a015"
import script from "./BlockForm.vue?vue&type=script&lang=ts"
export * from "./BlockForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports